import { useContext } from 'react';

import { HoneycombStoreContext } from '../context/honeycomb-store.context.js';
import {
  HoneycombOverlayState,
  HoneycombSelectionState,
  HoneycombTooltipState,
} from '../types/state.js';

const useSetState = () => {
  const { setState } = useContext(HoneycombStoreContext);

  return setState;
};

export const useSetStateTooltip = () => {
  const setState = useSetState();

  return (newTooltipState: Partial<HoneycombTooltipState>) => {
    setState((prev) => ({
      ...prev,
      tooltip: {
        ...prev.tooltip,
        ...newTooltipState,
      },
    }));
  };
};

export const useToggleStatePinnedTooltip = () => {
  const setState = useSetState();

  return () => {
    setState((prev) => {
      if (prev.tooltip.visible || prev.tooltip.pinned) {
        return {
          ...prev,
          tooltip: {
            ...prev.tooltip,
            pinned: !prev.tooltip.pinned,
          },
        };
      }
      return { ...prev };
    });
  };
};

export const useSetStateSelection = () => {
  const setState = useSetState();

  return (newSelectionState: Partial<HoneycombSelectionState>) => {
    setState((prev) => ({
      ...prev,
      selection: {
        ...prev.selection,
        ...newSelectionState,
      },
    }));
  };
};

export const useSetStateOverlay = () => {
  const setState = useSetState();

  return (newOverlayState: Partial<HoneycombOverlayState>) => {
    setState((prev) => ({
      ...prev,
      overlay: {
        ...prev.overlay,
        ...newOverlayState,
      },
    }));
  };
};
